import React from 'react';
import { ResumeData } from '../../../../../types/resume';
import CertificationsList from './CertificationsList';
import CertificationsHeader from './CertificationsHeader';
import { Plus } from 'lucide-react';

interface Props {
  data: ResumeData;
  onUpdate: (data: Partial<ResumeData>) => void;
}

export default function CertificationsForm({ data, onUpdate }: Props) {
  const certifications = data.certifications || [];

  const addCertification = () => {
    onUpdate({
      certifications: [...certifications, {
        id: crypto.randomUUID(),
        name: '',
        issuer: '',
        issueDate: '',
        expiryDate: '',
        credentialId: '',
        url: ''
      }]
    });
  };

  return (
    <div className="space-y-6">
      <CertificationsHeader />
      
      <CertificationsList
        certifications={certifications}
        onUpdate={(updatedCertifications) => onUpdate({ certifications: updatedCertifications })}
      />

      <button
        onClick={addCertification}
        className="w-full py-3 border-2 border-dashed border-gray-300 rounded-lg text-gray-600 hover:border-blue-500 hover:text-blue-500 flex items-center justify-center gap-2 transition-colors"
      >
        <Plus className="h-5 w-5" />
        Add Certification
      </button>
    </div>
  );
}